export default __webpack_public_path__ + "images/assets/0459923efe5bac7b876986ab2981d5cd.svg";